import ModalBox, { ModalBody, ModalHeader } from "../../ModalBox";
import CustomerSignUp from "./Registration";
import CustomerLogin from "./Login";
import TabsBox, { TabBody } from "../../../Tabs";
import ForgotPasswordModal from "../../../Auth/ForgotPassword";
import React, { useState } from "react";
import ResendVerification from "../../../Auth/ResendVerification";
import {
  sendOtp,
  setupRecaptcha,
  fpSendMail,
} from "../../../../services/customer/auth";
import { getAuth } from "firebase/auth";
import { app } from "../../../../firebase";
import useDisableScroll from "../../../../hooks/useDisableScrollBar";

interface CustomerAuthModalProps {
  modalShow: boolean;
  closeModal: () => void;
  setOtpModal?: React.Dispatch<React.SetStateAction<boolean>>;
  setContactNumber?: React.Dispatch<React.SetStateAction<string>>;
}

const CustomerAuthModal: React.FC<CustomerAuthModalProps> = ({
  modalShow,
  closeModal,
  setOtpModal,
  setContactNumber,
}) => {
  const defaultCurrentTabName = "login";
  useDisableScroll(modalShow);

  const [currentTabName, setCurrentTabName] = useState<string>(
    defaultCurrentTabName
  );
  const [resendVerification, setResendVerification] = useState<any>({
    show: false,
    contact_number: "",
  });
  const [resendVerificationLoading, setResendVerificationLoading] =
    useState<boolean>(false);

  const handleCurrentTab = (tabName: string) => {
    setCurrentTabName(tabName);
  };

  // Note: Forgot Password modal Start
  const [stateFPModal, setStateFPModal] = useState<boolean>(false);
  const [stateLoading, setStateLoading] = useState<boolean>(false);
  const [stateApiResponse, setStateApiResponse] = useState<{
    status: boolean;
    email: string;
  }>({ status: false, email: "" });

  const handleApiResponse = (res: any) => {
    if (res.status === 200) {
      setStateApiResponse((preview) => ({ ...preview, status: true }));
      setStateLoading(false);
    } else {
      setStateApiResponse((preview) => ({ ...preview, status: false }));
      setStateLoading(false);
      setStateFPModal(false);
    }
  };

  const handleLoading = (value: boolean) => {
    setStateLoading(value);
  };

  const handleModalOpen = () => {
    setStateApiResponse({ status: false, email: "" });
    setStateFPModal(true);
  };

  const handleModalClose = () => {
    setStateApiResponse({ status: false, email: "" });
    setStateFPModal(false);
  };

  const handleVerifyModalClose = () => {
    setResendVerification({
      show: false,
      contact_number: "",
    });
  };

  const handleForgotOnSubmit = (values: any) => {
    setStateLoading(true);
    setStateApiResponse((preview) => ({ ...preview, email: values?.email }));
    const apiData = {
      email: values?.email?.toLowerCase(),
    };
    fpSendMail(handleApiResponse, handleLoading, apiData);
  };

  const handleVerificationPopup = (
    statusCode: number,
    contact_number: string
  ) => {
    if (statusCode === 434) {
      setResendVerification({ show: true, contact_number });
    }
  };

  const auth = getAuth(app);

  const handleResendVerificationOTP = (contact_number: string) => {
    setContactNumber && setContactNumber(`+91${contact_number}`);
    setResendVerificationLoading(true);
    setupRecaptcha(auth);

    const appVerifier = (window as Window | any).recaptchaVerifier;
    sendOtp(appVerifier, auth, `+91${contact_number}`, (confirmation: any) => {
      setResendVerificationLoading(false);
      if (confirmation) {
        setOtpModal && setOtpModal(true);
        (window as Window | any).confirmationResult = confirmation;
      }
    });
  };

  return (
    <>
      <ModalBox
        show={modalShow}
        closeModal={closeModal}
        className="customer-auth-modal"
        classList={{
          modalOutSideClassName: "!p-0 sm:!p-4",
          modalWidth: "!p-0 small:!p-4",
        }}
      >
        <ModalHeader className="p-6">
          <h3 className="font-bold text-2xl text-center">
            Welcome to savitar realty
          </h3>
        </ModalHeader>
        <ModalBody className="px-4">
          <TabsBox
            defaultEventKey={defaultCurrentTabName}
            currentTab={handleCurrentTab}
          >
            <TabBody eventKey="login" title="Sign In">
              <CustomerLogin
                closeModal={closeModal}
                handleForgotPasswordModal={handleModalOpen}
                handleVerificationPopup={handleVerificationPopup}
              />
            </TabBody>
            <TabBody eventKey="registration" title="New Account">
              <CustomerSignUp
                show={modalShow}
                closeModal={closeModal}
                currentTabName={currentTabName}
                setOtpModal={setOtpModal}
                setContactNumber={setContactNumber}
              />
            </TabBody>
          </TabsBox>
        </ModalBody>
      </ModalBox>

      <ForgotPasswordModal
        showModal={stateFPModal}
        handleOnSubmit={handleForgotOnSubmit}
        btnLoader={stateLoading}
        closeModal={handleModalClose}
        successModal={stateApiResponse.status}
        sendedEmail={stateApiResponse.email?.toLowerCase()}
        signInClick={handleModalClose}
      />
      {resendVerification?.show && (
        <ResendVerification
          showModal={resendVerification?.show}
          closeModal={handleVerifyModalClose}
          btnLoader={resendVerificationLoading}
          contactNumber={resendVerification?.contact_number}
          handleClick={handleResendVerificationOTP}
        />
      )}
    </>
  );
};

export default CustomerAuthModal;
